<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<div class="container-fluid" *ngIf="accessService.hasAccess([], ['types.menu'])">
  <div class="row align-items-center">
    <div class="col-auto">
      <h5 class="title-secondary">{{ 'TYPES.TYPES_LIST.TITLE' | translate }}</h5>
    </div>
    <div class="col-auto ms-auto">
      <button type="button" class="btn btn-link btn-clear-filters" (click)="clearFilters()">
        {{ 'CLEAR_FILTERS' | translate }}
      </button>

      <button
        *ngIf="accessService.hasAccess([], ['types.store'])"
        class="btn btn-secondary"
        type="button"
        (click)="add()"
      >
        {{ 'TYPES.TYPES_LIST.ADD_TYPE' | translate }}
      </button>
    </div>
  </div>

  <kendo-grid
    [data]="data"
    [pageSize]="typesResponse?.meta.per_page"
    [sortable]="true"
    [filterable]="true"
    [columnMenu]="true"
    [filter]="state?.filter"
    [sort]="state?.sort"
    [skip]="state?.skip"
    [pageable]="true"
    (dataStateChange)="loadData($event)"
    (columnVisibilityChange)="onVisibilityChange($event)"
    #grid
    (excelExport)="onExcelExport($event, 'Types', grid)"
  >
    <kendo-grid-column
      [width]="70"
      class="text-center"
      headerClass="text-center"
      title="{{ 'TYPES.TYPES_LIST.NUMBER' | translate }}"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        {{ rowIndex + 1 }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="id"
      title="{{ 'TYPES.TYPES_LIST.ID' | translate }}"
      filter="numeric"
      [width]="150"
      [hidden]="isHiddenColumn('id')"
    ></kendo-grid-column>

    <kendo-grid-column
      field="type"
      title="{{ 'TYPES.TYPES_LIST.TYPE' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('type')"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        <div class="color-text">
          {{ dataItem.type }}
        </div>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="value"
      title="{{ 'TYPES.TYPES_LIST.VALUE' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('value')"
    ></kendo-grid-column>

    <kendo-grid-column
      field="real_value"
      title="{{ 'TYPES.TYPES_LIST.REAL_VALUE' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('real_value')"
    ></kendo-grid-column>

    <kendo-grid-column
      field="color"
      title="{{ 'TYPES.TYPES_LIST.COLOR' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('color')"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        <div class="d-flex align-items-center">
          <div class="color-box me-3" [style.background-color]="dataItem.color"></div>
          <div class="color-text">{{ dataItem.color }}</div>
        </div>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      [width]="100"
      field="order_index"
      title="{{ 'TYPES.TYPES_LIST.ORDER_INDEX' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('order_index')"
      [filterable]="false"
    ></kendo-grid-column>

    <kendo-grid-column
      field="active"
      title="{{ 'TYPES.TYPES_LIST.ACTIVE' | translate }}"
      filter="boolean"
      [width]="150"
      [class]="'text-center'"
      [hidden]="isHiddenColumn('active')"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        <app-active-indicator [active]="dataItem.active"></app-active-indicator>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      title="{{ 'TYPES.TYPES_LIST.ACTIONS' | translate }}"
      [width]="100"
      [class]="'text-center'"
      [includeInChooser]="false"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <app-edit-button *ngIf="accessService.hasAccess([], ['types.show'])" (click)="edit(dataItem)">
        </app-edit-button>

        <app-delete-button
          *ngIf="accessService.hasAccess([], ['types.destroy'])"
          [swal]="{}"
          (confirm)="delete(dataItem)"
        >
        </app-delete-button>
      </ng-template>
    </kendo-grid-column>

    <ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
      <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
      <kendo-pager-input></kendo-pager-input>
      <kendo-pager-info></kendo-pager-info>
      <kendo-pager-next-buttons></kendo-pager-next-buttons>
      <kendo-pager-page-sizes [pageSizes]="env.kendoGridPageSizes"></kendo-pager-page-sizes>
      <app-kendo-grid-refresh-button (click)="loadData(state)"></app-kendo-grid-refresh-button>
      <button type="button" class="btn kendo-export-btn" [disabled]="grid.loading" kendoGridExcelCommand>
        {{ 'EXPORT_TO_EXCEL' | translate }}
      </button>
    </ng-template>

    <kendo-grid-excel></kendo-grid-excel>
  </kendo-grid>
</div>
